import { render, staticRenderFns } from "./planeacion.vue?vue&type=template&id=6cfcf532&scoped=true"
import script from "./planeacion.vue?vue&type=script&lang=js"
export * from "./planeacion.vue?vue&type=script&lang=js"
import style0 from "./planeacion.vue?vue&type=style&index=0&id=6cfcf532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfcf532",
  null
  
)

export default component.exports